import React from "react";
import { NavLink , useLocation} from "react-router-dom";

const ProfileTabs = () => {
    const loc = useLocation();
    const currentHash = loc.hash || '#general'; // Default to general if no hash
    
return (
    <ul className="tabs clearfix" data-tabgroup="first-tab-group">
        <li><NavLink to="#general" className={() => currentHash === '#general' || currentHash === '' ? "active" : ""}>General</NavLink></li>
        <li><NavLink to="#skills" className={() => currentHash === '#skills' ? "active" : ""}>Skills</NavLink></li>
        <li><NavLink to="#education" className={() => currentHash === '#education' ? "active" : ""}>Education</NavLink></li>
        <li><NavLink to="#references" className={() => currentHash === '#references' ? "active" : ""}>References</NavLink></li>
        <li><NavLink to="#contacts" className={() => currentHash === '#contacts' ? "active" : ""}>Contacts</NavLink></li>
        <li><NavLink to="#health" className={() => currentHash === '#health' ? "active" : ""}>Health</NavLink></li>
        <li><NavLink to="#insurance" className={() => currentHash === '#insurance' ? "active" : ""}>Insurance</NavLink></li>
        <li><NavLink to="#passport" className={() => currentHash === '#passport' ? "active" : ""}>Passport</NavLink></li>
        <li><NavLink to="#church" className={() => currentHash === '#church' ? "active" : ""}>Church</NavLink></li>
        <li><NavLink to="#settings" className={() => currentHash === '#settings' ? "active" : ""}>Settings</NavLink></li>
      </ul>
)
}

export default ProfileTabs;